import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCog } from "react-icons/fa";
import { motion } from "framer-motion";

const gatewaysData = [
  {
    name: "PayPal",
    desc: "PayPal is the faster, safer way to send and receive money or make an online payment.",
  },
  {
    name: "Stripe",
    desc: "APIs to accept credit cards, manage subscriptions, send money.",
  },
  {
    name: "Skrill",
    desc: "Allow send international money transfers and payments quickly with low fees.",
  },
  {
    name: "Paytm",
    desc: "Paytm sends for pay through mobile and its India's largest mobile payments.",
  },
];

const PaymentGates = () => {
  const [gateways, setGateways] = useState(
    gatewaysData.map((g) => ({ ...g, active: true }))
  );

  const toggleGateway = (index) => {
    const updated = [...gateways];
    updated[index].active = !updated[index].active;
    setGateways(updated);
  };

  return (
    <motion.div
      className=" card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        Payment Gateways
      </motion.h5>

      <div className="row g-4">
        {gateways.map((item, index) => (
          <div className="col-md-6" key={index}>

            <motion.div
              className="card shadow-sm border-0 p-3 h-100 rounded-4"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              whileTap={{ scale: 0.97 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
            >

              {/* Header */}
              <motion.div
                className="d-flex justify-content-between align-items-center mb-2"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.1 }}
              >
                <span className="badge bg-light text-dark">
                  {item.name}
                </span>

                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={item.active}
                    onChange={() => toggleGateway(index)}
                  />
                </div>
              </motion.div>

              {/* Description */}
              <motion.p
                className="text-muted small"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.15 }}
              >
                {item.desc}
              </motion.p>

              <hr />

              {/* Footer */}
              <motion.div
                className="d-flex justify-content-between align-items-center"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
              >
                <motion.button
                  whileTap={{ scale: 0.9 }}
                  className={`btn btn-sm ${item.active ? "btn-primary" : "btn-secondary"
                    }`}
                >
                  {item.active ? "✔ Connected" : "✖ Disconnected"}
                </motion.button>

                <motion.div
                  whileHover={{ rotate: 90 }}
                  transition={{ duration: 0.3 }}
                >
                  <FaCog />
                </motion.div>
              </motion.div>

            </motion.div>

          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default PaymentGates;